import { render } from "./TimelineCard.vue?vue&type=template&id=561ae6a8&ts=true"
import script from "./TimelineCard.vue?vue&type=script&lang=ts"
export * from "./TimelineCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__